import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=a956a56e&"
var script = {}
import style0 from "./HeaderSection.vue?vue&type=style&index=0&id=a956a56e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports